import { RootState } from '../../store';
import { createSelector } from '@reduxjs/toolkit';

const AppReducer = (state: RootState): RootState['AppReducer'] => state.AppReducer;
const selectAppState = createSelector([AppReducer], (state) => state);

export const selectInitilized = createSelector([selectAppState], (state) => state.initialized);